/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import {
    USERS_RECEIVE,
    USERS_REQUEST,
    USERS_REQUEST_SUCCESS,
    USERS_REQUEST_FAILURE,
    CURRENT_USER_RECEIVE,
} from 'state/action-types';

/**
 * Plans `Reducer` function
 * root state -> state.users.items =>
 * [ {}, {}, ... {} ]
 *
 * @param {Object} state - current state
 * @param {Object} action - users action
 * @return {Object} updated state
 */
export const items = (state = {}, action) => {
    switch (action.type) {
        case USERS_RECEIVE:
            return action.users.slice(0);
        case CURRENT_USER_RECEIVE:
            let id = get(action, 'user.user.id');
            if (!id) {
                return state;
            }
            return { ...state, [action.user.user.id]: action.user.user };
        default:
            return state;
    }
};

/**
 * `Reducer` function which handles request/response actions
 * to/from REST-API
 *
 * @param {Object} state - current state
 * @param {Object} action - users action
 * @return {Object} updated state
 */
export const requesting = (state = false, action) => {
    switch (action.type) {
        case USERS_REQUEST:
        case USERS_REQUEST_SUCCESS:
        case USERS_REQUEST_FAILURE:
            return action.type === USERS_REQUEST;
        default:
            return state;
    }
};

/**
 * `Reducer` function which handles ERROR REST-API response actions
 *
 * @param {Object} state - current state
 * @param {Object} action - users action
 * @return {Object} updated state
 */
export const error = (state = false, action) => {
    switch (action.type) {
        case USERS_REQUEST:
        case USERS_REQUEST_SUCCESS:
            return false;

        case USERS_REQUEST_FAILURE:
            return true;
        default:
            return state;
    }
};

export default combineReducers({
    items,
    requesting,
    error,
});
